import Styles from './ProcessingContent.module.scss'
import { Spinner } from 'common/Spinner/Spinner'
import { Text } from 'blaze-ui/Text/Text'
import { ProcessingContentProps } from './Types'
import { DesignProcessingMessage } from './DesignPreview/DesignProcessingMessage'
import { ProcessingSteps } from './ProcessingSteps/ProcessingSteps'
import { useAbortMessage } from 'hooks/queries/chat/useAbortMessage'
import { Button } from 'blaze-ui/Button'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { ReviseDesignProcessingContent } from 'api/clients/ChatClient'

const ESTIMATED_MINUTES: Record<string, number> = {
  generate_photo: 2,
  generate_video: 3,
}

export const ProcessingContent = ({ content, message }: ProcessingContentProps) => {
  const isChatV2 = useFlipperFlag('chat_v2')
  const { mutate: abortMessage } = useAbortMessage()
  const isSystemRedesignEnabled = useIsSystemRedesign()

  const handleAbort = () => {
    if (message) {
      abortMessage({ threadId: message.thread_id, id: message.id })
    }
  }

  const toolName = 'tool' in content ? content.tool : undefined
  const steps = 'steps' in content && content.steps?.length ? content.steps : undefined

  return (
    <>
      {steps ? (
        <ProcessingSteps steps={steps} estimatedMinutes={toolName ? ESTIMATED_MINUTES[toolName] : undefined} />
      ) : (
        <div className={Styles.loading}>
          <div className={Styles.loadingContent}>
            <Spinner variant={isSystemRedesignEnabled ? undefined : 'blue'} />
            <div className={Styles.loadingText}>
              <Text variant="secondary">{content.text || 'Reading your message...'}</Text>
            </div>
          </div>
          {!isChatV2 && (
            <Button variant="ghost" size="sm" onPress={handleAbort}>
              <Text variant="smallList">Cancel</Text>
            </Button>
          )}
        </div>
      )}
      {toolName === 'revise_design' && <DesignProcessingMessage content={content as ReviseDesignProcessingContent} />}
    </>
  )
}
